module.exports = __webpack_public_path__ + "img/mercafacil-dark.f33fc445.svg";